import { render, staticRenderFns } from "./SupplierPlasticMaintain.vue?vue&type=template&id=1857c071&scoped=true"
import script from "./SupplierPlasticMaintain.vue?vue&type=script&lang=js"
export * from "./SupplierPlasticMaintain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1857c071",
  null
  
)

export default component.exports